export const XUC_CURRENCY_CODE = 'XUC';
export const XTD_CURRENCY_CODE = 'XTD';
